/**
 * SuperTokens Frontend SDK Client Plugin
 *
 * This plugin initializes the SuperTokens Web JS SDK on the client-side only.
 * It configures EmailPassword and Session recipes.
 */

import SuperTokens from "supertokens-web-js";
import Session from "supertokens-web-js/recipe/session";
import EmailPassword from "supertokens-web-js/recipe/emailpassword";
import EmailVerification from "supertokens-web-js/recipe/emailverification";
import ThirdParty from "supertokens-web-js/recipe/thirdparty";

export default defineNuxtPlugin(() => {
  // CRITICAL: Only run on client-side
  if (import.meta.server) {
    return;
  }

  if (import.meta.dev) {
    console.log("🚀 SuperTokens client plugin is loading...");
  }

  try {
    const config = useRuntimeConfig();

    // Get configuration from runtime config (public keys)
    const apiDomain =
      config.public.supertokensApiDomain || window.location.origin;
    const apiBasePath = config.public.supertokensApiBasePath || "/api/auth";

    if (import.meta.dev) {
      console.log("🔄 Initializing SuperTokens Web SDK...");
      console.log(`   API Domain: ${apiDomain}`);
      console.log(`   API Base Path: ${apiBasePath}`);
    }

    // Initialize SuperTokens
    SuperTokens.init({
      appInfo: {
        appName: "Veterina Pohotovost",
        apiDomain,
        apiBasePath,
      },
      recipeList: [
        EmailPassword.init(),
        EmailVerification.init(),
        ThirdParty.init(),
        Session.init(),
      ],
    });

    if (import.meta.dev) {
      console.log("✅ SuperTokens Web SDK initialized successfully");
    }

    // Check if user has an active session on app load
    // This updates the reactive auth state in useAuth composable
    const { checkSession } = useAuth();
    checkSession()
      .then((hasSession) => {
        if (import.meta.dev) {
          if (hasSession) {
            console.log("🔒 Active session found");
          } else {
            console.log("ℹ️ No active session");
          }
        }
      })
      .catch((sessionError) => {
        console.warn("⚠️ Failed to check session:", sessionError);
      });
  } catch (error) {
    console.error("❌ CRITICAL: Failed to initialize SuperTokens Web SDK");
    console.error("   Error:", error);
    console.error("   Stack:", error instanceof Error ? error.stack : "N/A");

    // Throw the error to make it visible that auth is broken
    throw new Error(
      `SuperTokens initialization failed: ${error instanceof Error ? error.message : String(error)}`
    );
  }
});
